/**
 * ProductFruits Type Definitions
 * Discriminated union types for type-safe postMessage handling
 */

/**
 * Type guards for message validation
 */
export function isIframeReadyMessage(msg) {
  return (
    typeof msg === 'object' &&
    msg !== null &&
    'type' in msg &&
    msg.type === 'IFRAME_READY' &&
    'app' in msg &&
    typeof msg.app === 'string'
  );
}

export function isUserAuthenticatedMessage(msg) {
  return (
    typeof msg === 'object' &&
    msg !== null &&
    'type' in msg &&
    msg.type === 'USER_AUTHENTICATED' &&
    'userData' in msg &&
    'shouldInitProductFruits' in msg &&
    typeof msg.shouldInitProductFruits === 'boolean'
  );
}

export function isTourEventMessage(msg) {
  return (
    typeof msg === 'object' &&
    msg !== null &&
    'type' in msg &&
    msg.type === 'TOUR_EVENT' &&
    'event' in msg &&
    'tourId' in msg &&
    typeof msg.tourId === 'string'
  );
}

export function isUserPropertyUpdateMessage(msg) {
  return (
    typeof msg === 'object' &&
    msg !== null &&
    'type' in msg &&
    msg.type === 'USER_PROPERTY_UPDATE' &&
    'props' in msg &&
    typeof msg.props === 'object' &&
    msg.props !== null
  );
}

